import Link from '@/components/atoms/link';
import Spinner from '../spinner';
import ReviewOrderSummary from './components/order-summary';
import { Cart } from '@shared/types/cart/Cart';
import ReviewHeader from './components/header';
import DeliveryAddressDetails from './components/sections/DeliveryAddressDetails';
import DeliveryMethod from './components/sections/DeliveryMethod';
import { ShippingMethod } from '@shared/types/cart/ShippingMethod';
import OtherDetails from './components/sections/OtherDetails';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop } from '@/constants/screensizes';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';

interface ReviewProps {
    cart?: Cart;
    loading: boolean;
    ShippingMethodName: string;
    Address: string;
    Postcode: string;
    Country: string;
    First_Name: string;
    Last_Name: string;
    shippingMethods?: ShippingMethod[]
    State: string;
    Suburb: string;
    City: string;
    DeliveryInstructions: string;
    handleReview: any
    Phone: string
    ctOrderNumber?: string;
}

const Review = ({
    cart,
    loading,
    shippingMethods,
    ShippingMethodName,
    Address,
    Postcode,
    Country,
    First_Name,
    Last_Name,
    State,
    Suburb,
    DeliveryInstructions,
    handleReview,
    Phone,
    City,
    ctOrderNumber,
}: ReviewProps) => {
    const [isDesktop] = useMediaQuery(desktop);

    const isLoading = (loading || !cart);
    const name = `${First_Name}${Last_Name ? ` ${Last_Name}` : ''}`;
    return (
        <>
            {isLoading && <Spinner />}
            {isLoading && <div className="overlay fixed left-0 top-0 z-[1002] h-full lg:w-full w-96 lg:bg-gray-800 bg-[f7f7f7] opacity-75"></div>}
            <div className="min-h-screen h-full lg:border bg-[ffffff] relative" style={{ backgroundColor: "#F7F7F7" }}>
                {!isLoading && <div className="flex flex-col sm:pt-0 sm:pb-0 pt-5 pb-2.5 sm:py-4 md:py-6 lg:items-start  bg-[#F3EDE9] lg:pt-7 lg:pb-4 lg:py-0 px-4 lg:px-12">
                    <ReviewHeader handleReview={handleReview} sum={cart?.sum} />
                    <div className='md:bg-[#FFFFFF] lg:mt-8 lg:ml-16 xl:mr-16 lg:mb-1 mb-2 h-auto lg:border md:py-6'>
                        {isDesktop && <div className='mt-6  mt-1 lg:ml-8 ml-2'>
                            <div>
                                <Link link={"/cart"}>
                                    <div className='flex items-center gap-2' >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 19L8 12L15 5" stroke="#090909" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span className='text-[18px]' >Back to Cart</span>
                                    </div>
                                </Link>
                            </div>
                        </div>}
                        <div className=' grid lg:grid-cols-5 grid-cols-1 lg:-mt-2 mmt-2'>
                            <div className='lg:col-span-2 mt-1 lg:ml-4 2xl:ml-20 ml-2'>
                                <DeliveryAddressDetails
                                    address={Address}
                                    postCode={Postcode}
                                    country={Country}
                                    name={name}
                                    suburb={Suburb}
                                    state={State}
                                    phone={Phone}
                                    city={City}
                                />
                                <DeliveryMethod
                                    shippingMethods={shippingMethods ?? []}
                                    selectedShippingMethodName={ShippingMethodName}
                                />
                                <OtherDetails deliveryInstructions={DeliveryInstructions} />
                            </div>
                            <div className='lg:col-span-3 lg:mx-4 2xl:mx-10 mx-2 h-auto  bg-[#F3EDE9]'>
                                {cart.lineItems &&
                                    <ReviewOrderSummary
                                        handleReview={handleReview}
                                        subTotal={cart?.sum}
                                        total={cart?.total}
                                        gst={cart?.gst}
                                        lineItems={cart.lineItems}
                                        vouchers={(cart as any)?.vouchers}
                                        FirstName={First_Name}
                                        LastName={Last_Name}
                                        Address={Address}
                                        Postcode={Postcode}
                                        Country={Country}
                                        State={State}
                                        Suburb={Suburb}
                                        Phone={Phone}
                                        City={City}
                                        cartId={cart?.meta?.cartSummary?.cartId}
                                        ctOrderNumber={ctOrderNumber}
                                    />}
                            </div>

                        </div>
                    </div>
                </div>}
            </div>
        </>
    );
};

export default Review;
